import { convertToInt } from "./convert-number";

export const calculateLvr = (estimateProperty, cashTowardProperty) => {
  const lvr =
    convertToInt(
      ((estimateProperty - cashTowardProperty) * 100) / estimateProperty
    ) || 0;
  return lvr < 0 ? 0 : lvr;
};
